import { useQuery } from '@tanstack/react-query';

import { TaggregatedCheckIns, Tleaves } from '../../../types/analyticsTypes';
import { getCheckInsData } from '../queries/getCheckInsData';

export const useGetAggregatedCheckinsData = (
  startDate: string,
  endDate: string,
): {
  data:
    | {
        aggregatedCheckIns: TaggregatedCheckIns[];
        leaves: Tleaves[];
      }
    | undefined;
  isLoading: boolean;
  error: Error | null;
} => {
  return useQuery({
    queryKey: ['check-in-count', startDate, endDate],
    queryFn: () => getCheckInsData(startDate, endDate),
    enabled: !!startDate && !!endDate,
  });
};
